/**
 * @generated SignedSource<<2e26d0357125afc82e67aed5bcc71388>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type cursosEnabledQuery$variables = {
  slug: string;
};
export type cursosEnabledQuery$data = {
  readonly club: {
    readonly configuration: string | null | undefined;
  };
};
export type cursosEnabledQuery = {
  response: cursosEnabledQuery$data;
  variables: cursosEnabledQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "key",
      "value": "COURSES_ENABLED"
    }
  ],
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"COURSES_ENABLED\")"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "cursosEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "cursosEnabledQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "35db8ec83117eac5e1a89af6b61d9a69",
    "id": null,
    "metadata": {},
    "name": "cursosEnabledQuery",
    "operationKind": "query",
    "text": "query cursosEnabledQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    configuration(key: \"COURSES_ENABLED\")\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "64a96e384353cef896cd5b6535191feb";

export default node;
